import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreloadAllModules } from '@angular/router';
import { HomeComponent } from 'src/app/home/home.component';
import { AuthGuard } from 'src/app/helpers/auth.guard';
import { MakePasswComponent } from 'src/app/components/make-passw/make-passw.component';

const accountModule = () => import('src/app/account/account.module').then(x => x.AccountModule);
const projectModule = () => import('src/app/components/project/project.module').then(x => x.ProjectModule);
const clinicalModule = () => import('src/app/components/clinical-study/clinical-study.module').then(x => x.ClinicalStudyModule);
const patientModule = () => import('src/app/components/patient/patient.module').then(x => x.PatientModule);
const usersModule = () => import('src/app/components/user/user.module').then(x => x.UserModule);
const mammographyModule = () => import('src/app/components/mammography/mammography.module').then(x => x.MammographyModule);
const ecographyModule = () => import('src/app/components/ecography/ecography.module').then(x => x.EcographyModule);
const histologicalBirdModule = () => import('src/app/components/histological-bird/histological-bird.module').then(x => x.HistologicalBirdModule);
const magneticResModule = () => import('src/app/components/magnetic-resonance/magnetic-resonance.module').then(x => x.MagneticResonanceModule);
const mammoFindingModule = () => import('src/app/components/mammography-finding/mammography-finding.module').then(x => x.MammographyFindingModule);
const ecoFindingsModule = () => import('src/app/components/ecography-finding/ecography-finding.module').then(x => x.EcographyFindingModule);
const mgrFindingModule = () => import('src/app/components/magneticr-finding/magneticr-finding.module').then(x => x.MagneticrFindingModule);
const finalassModule = () => import('src/app/components/final-assesment/final-assesment.module').then(x => x.FinalAssesmentModule);
const groupModule = () => import('src/app/components/group/group.module').then(x => x.GroupModule);
const preportModule = () => import('src/app/components/project-report/project-report.module').then(x => x.ProjectReportModule);
const measurModule = () => import('src/app/components/measurement/measurement.module').then(x => x.MeasurementModule);
const measurrepModule = () => import('src/app/components/measur-report/measur-report.module').then(x => x.MeasurReportModule);
const auditModule = () => import('src/app/components/audit/audit.module').then(x => x.AuditModule);
const surveyrepRoutes = () => import('src/app/components/survey-report/survey-report.routes').then(x => x.SURVEY_REPORT_ROUTES);

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'projects', loadChildren: projectModule, canActivate: [AuthGuard] },
  { path: 'clinical-studies', loadChildren: clinicalModule, canActivate: [AuthGuard] },
  { path: 'patients', loadChildren: patientModule, canActivate: [AuthGuard] },
  { path: 'users', loadChildren: usersModule, canActivate: [AuthGuard] },
  { path: 'mammographies', loadChildren: mammographyModule, canActivate: [AuthGuard] },
  { path: 'ecographies', loadChildren: ecographyModule, canActivate: [AuthGuard] },
  { path: 'histologicals', loadChildren: histologicalBirdModule, canActivate: [AuthGuard] },
  { path: 'magnetics', loadChildren: magneticResModule, canActivate: [AuthGuard] },
  { path: 'mammofindings', loadChildren: mammoFindingModule, canActivate: [AuthGuard] },
  { path: 'ecofindings', loadChildren: ecoFindingsModule, canActivate: [AuthGuard] },
  { path: 'mgrfindings', loadChildren: mgrFindingModule, canActivate: [AuthGuard] },
  { path: 'finalassesments', loadChildren: finalassModule, canActivate: [AuthGuard] },
  { path: 'account', loadChildren: accountModule },
  { path: 'make-passw/:token', component: MakePasswComponent },
  { path: 'make-passw/lost/:token', component: MakePasswComponent },
  { path: 'groups', loadChildren: groupModule, canActivate: [AuthGuard] },
  { path: 'measurements', loadChildren: measurModule, canActivate: [AuthGuard] },
  { path: 'reports/project', loadChildren: preportModule, canActivate: [AuthGuard] },
  { path: 'reports/measurement', loadChildren: measurrepModule, canActivate: [AuthGuard] },
  { path: 'reports/survey', loadChildren: surveyrepRoutes, canActivate: [AuthGuard] },
  { path: 'audits', loadChildren: auditModule, canActivate: [AuthGuard] },

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      preloadingStrategy: PreloadAllModules
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
